import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export const AlertDialog = ({
  children,
  title = "",
  description = "",
  open = false,
  handleConfirm,
  handleClose,
  cancelBtn = "CANCEL",
  confirmBtn = "SAVE",
  maxWidth,
  zIndex,
  saveDisable = false,
}: any) => {
  return (
    <Dialog
      open={open}
      maxWidth={maxWidth}
      keepMounted
      fullWidth
      sx={zIndex && { zIndex }}
    >
      {title !== "" ? (
        <DialogTitle id={`alert_title_${title}`}>{title}</DialogTitle>
      ) : null}
      {description !== "" || children ? (
        <DialogContent>
          <DialogContentText id={`alert_desc_${title}`}>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </DialogContentText>
          {children}
        </DialogContent>
      ) : null}
      <DialogActions>
        <Button
          className="grey-btn"
          onClick={handleClose}
          id={title ? `${title}-${cancelBtn}` : `${cancelBtn}`}
        >
          {cancelBtn}
        </Button>
        <Button
          onClick={handleConfirm}
          autoFocus
          id={title ? `${title}-${confirmBtn}` : `${confirmBtn}`}
          disabled={saveDisable}
        >
          {confirmBtn}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
